import React from "react";
import { PageHeader } from "../../../components";

export default function HONTREASURER() {
  return (
    <div className="page-content">
      <PageHeader title="Management Details" page="management details" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          <div className="section-fullbg-gray content-inner bg-gray ">
            <div className="container">
              <div className="row">
                <div className="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="./assets/images/members/LCC_TREASURER.jpg"
                    alt=""
                    className="m-b30"
                    width="440"
                  />
                </div>
                <div className="col-md-7 col-sm-12">
                  <h3 className="h3">MR. OLUSEGUN OWADOKUN</h3>
                  <div className="dlab-separator bg-primary"></div>
                  <h4 className="font-weight-3 00">
                  Olusegun Owadokun is an accomplished finance and investment professional with over 25 years of experience spanning banking, credit ratings, financial advisory, corporate finance, capital markets, and executive training. He is currently the Managing Partner of Jamacy consulting limited , where he leads rating advisory, governance-focused consulting and institutional capability development.
                  Prior to founding jamacy consulting, he served as Deputy Chief Executive Officer of Coronation Securities limited and Chief Operating Officer of Agusto Consulting Limited, Nigeria's foremost Pan-African Credit Rating Agency, and previously held banking roles at United Bank for Africa Plc and Zenith Bank PLC.

                  He holds a Bachelor’s Degree in Accounting from the University of Benin, Benin City, Nigeria, and a Master's in Investment Management (Distinction) from the ICMA Centre, Henley Business School, University of Reading, UK, He is also an alumnus of the Lagos Business School's Senior Management Programme (SMP)

                  Olusegun is a Fellow of the Institute of Chartered Accountants of Nigeria (FCA), a CFA Charterholder and holds the Certificate in Investment Performance Measurement (CIPM) designation of the CFA institute. He is a member of the Chartered Institute for Securities and Investment UK, and an Associate of the Chartered Institute of Stockbrokers, He is an Authorized Dealing Clerk of the Nigerian Exchange (NGX)
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
